import {Component, HostBinding, Input, OnInit, ViewChild, inject} from '@angular/core';
import {VtnGenericaComponent} from '../vtn-generica/vtn-generica.component';
import {ClsConfig} from '../../../../util/cls-config';
import { FilteringLogic, IgxStringFilteringOperand } from '@infragistics/igniteui-angular/core';
import { IGX_GRID_DIRECTIVES, IgxGridComponent, IgxGridModule } from '@infragistics/igniteui-angular/grids/grid';
import { IgxExcelExporterService, IgxPdfExporterService } from '@infragistics/igniteui-angular/grids/core';
import {EnumMasOpciones, EnumPosicionBtn} from '../../../../core/models/enum/enum-mas-opciones';
import {ClsUtil} from '../../../../util/cls-util';
import {FiltroGeneralComponent} from '../../controles/filtro-general/filtro-general.component';
import {ClsObjGenerico} from '../../../../clases-pu/util/cls-obj-generico';
import {GenericoService} from '../../../../core/services/generico.service';
import {AppInfoService} from '../../../../core/services/app-info.service';
import {AppPresupuestosService} from '../../../../core/services/app-presupuestos.service';
import {TranslateModule} from '@ngx-translate/core';
import {MasOpcionesGridComponent} from '../../controles/mas-opciones-grid/mas-opciones-grid.component';
import {INeodataBtnsFooter} from "../../../../core/models/interfaces/generico-interface";
import {ClsColDetallePegado} from "../../../../core/models/cls-pegado";
import {TipoMensajesService} from "../../../../core/services/tipo-mensajes.service";
import { CrearComponenteDinamicoService } from '../../../../core/services/crear-componente-dinamico.service';

@Component({
  selector: 'app-detalle-pegado',
  templateUrl: './detalle-pegado.component.html',
  styleUrls: ['./detalle-pegado.component.scss'],
  imports: [
    IgxGridModule,
    IGX_GRID_DIRECTIVES,
    TranslateModule,
    FiltroGeneralComponent,
    MasOpcionesGridComponent,
  ]
})
export class DetallePegadoComponent extends ClsConfig implements OnInit {
  private servicioGen = inject(GenericoService);
  private infApp = inject(AppInfoService);
  private infPpto = inject(AppPresupuestosService);
  private tipoMsg = inject(TipoMensajesService);
  private excelExportService = inject(IgxExcelExporterService);
  private pdfExportService = inject(IgxPdfExporterService);
  private crearCompDinamico = inject(CrearComponenteDinamicoService);

  @ViewChild('gridDetallePegado', {read: IgxGridComponent, static: true})
  public gridDetallePegado: IgxGridComponent;

  @ViewChild('filtroGeneral', {read: FiltroGeneralComponent, static: true})
  public filtroGeneral: FiltroGeneralComponent;

  // ajuste de texto
  @HostBinding('class') public themesClass = 'noAjustarTexto';
  public clicked = false;

  @Input()
  public dataDetalle: ClsColDetallePegado[];

  public vtnGenerico: VtnGenericaComponent;
  private mObjGenerico: ClsObjGenerico = new ClsObjGenerico();

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.vtnGenerico.evtBoton.subscribe(async (btn: INeodataBtnsFooter) => {
      switch (btn.id) {
        default: // cancelar
          this.close();
      }
    });
  }

  public open() {
    this.vtnGenerico.btnsAccion = [
      {
        id: 'CANCELAR',
        texto: 'BOTONES.CANCELAR',
        titulo: 'BOTONES.CANCELAR',
        icono: '',
        tipoBoton: 'flat',
        posicion: EnumPosicionBtn.DERECHO
      }
    ];
    this.vtnGenerico.open(400, 950, 'TITULOS.DETALLE_PEGADO', 'report');
  }

  public close() {
    this.vtnGenerico.close();
  }

  public clearInput() {
    this.filtroGeneral.input.value = '';
    this.gridDetallePegado.clearFilter();
  }

  public filterInput(filtro: string) {
    this.gridDetallePegado.filteringLogic = FilteringLogic.Or;
    this.gridDetallePegado.filterGlobal(filtro, IgxStringFilteringOperand.instance().condition('contains'));
  }

  public async onSelectionDropDown(opcion: string) {
    try {
      switch (opcion) {
        case EnumMasOpciones.Ajustar:
          this.clicked = !this.clicked;
          if (this.clicked) {
            this.themesClass = 'ajustarTexto';
          } else {
            this.themesClass = 'noAjustarTexto';
          }
          break;
        case EnumMasOpciones.ExportarExcel:
          await ClsUtil.exportarDatos(this.gridDetallePegado, this.mObjGenerico.getTranslationsSubject('TITULOS.DETALLE_PEGADO'), this.excelExportService);
          break;
        case EnumMasOpciones.ExportarPDF:
          await ClsUtil.abrirVentanaPersonalizarPDF(
            this.gridDetallePegado,
            this.mObjGenerico.getTranslationsSubject('TITULOS.DETALLE_PEGADO'),
            this.pdfExportService,
            this.crearCompDinamico,
            this.tipoMsg,
            this.mObjGenerico
          );
          break;
        case EnumMasOpciones.LimpiarFiltroColumnas:
          this.clearInput();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }
}

